import React from "react";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import i18n from "utils/I18n";
import { useTranslation } from "react-i18next";

import { enLocaleNumberFormatter, createAction } from "utils";
import { HIDE_POINT_TO_CASH_SECTION, WEB_DOMAIN } from "utils/Config";
import { navigateStack, inMiniProgram } from "utils/WeChatUtil";
import { getMaxCashDollar } from "./PointAndCashSection";

import { CashDollarIcon, InboxIcon, MyCardIcon, PointsIcon } from "component/base/SvgIcons";
import "./MobileViewPointAndCashInfo.scss"

const MobileViewPointAndCashInfo = ({
  currentPoints,
  messageUnreadCount,
  userId
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  useTranslation();
  const isInMiniProgram = inMiniProgram();
  const maxCashDollar = getMaxCashDollar(currentPoints);

  return <div className="mobile-profile-header-point-section">
    <div className="points-and-cash">
      <div className="points-section">
        <div className="tag-menu-1">{i18n.t("points")}</div>
        <div className="subheading">
          <PointsIcon />
          <div>{enLocaleNumberFormatter(currentPoints)}</div>
        </div>
      </div>
      {HIDE_POINT_TO_CASH_SECTION ? null :
        <>
          <div className="color-g4 subheading">{"="}</div>
          <div className="points-section">
            <div className="tag-menu-1">{i18n.t("cash_dollar")}</div>
            <div className="subheading">
              <CashDollarIcon />
              <div>{enLocaleNumberFormatter(maxCashDollar)}</div>
            </div>
          </div>
        </>
      }
    </div>
    <div className="inbox-and-card-icons">
      <InboxIcon
        onClick={() => {
          if (!isInMiniProgram) {
            navigateStack({ pathname: '/inbox', history })
            return
          }
          dispatch(createAction('weChat/checkMessageSubscribed')({
            onSuccess: () => {
              const nextUrl = `${WEB_DOMAIN}/inbox?`
              const weChatUrl = `/pages/push/push?redirect_url=${encodeURIComponent(nextUrl)}` + "&lang=" + encodeURIComponent(i18n.language) + "&uid=" + encodeURIComponent(userId)
              window.wx.miniProgram.navigateTo({ url: weChatUrl })
            },
            onFailed: () => {
              navigateStack({ pathname: '/inbox', history })
            }
          }));
        }}
      />
      <MyCardIcon
        onClick={() => {
          navigateStack({ pathname: '/user/myCard', history })
        }}
      />
    </div>
  </div>
}

const mapPropsToState = (state) => ({
  currentPoints: state.users.availablePoints,
  messageUnreadCount: state.inboxMessages.unReadCount,
  userId: state.users.userInfo.uid,
  language: state.users.language,
});

export default connect(mapPropsToState)(MobileViewPointAndCashInfo);